import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/service/auth.service';
import { GenericValidator } from 'src/app/validation/general-validation';
import { GSMConfigurationService } from 'src/app/Service/gsmconfiguration.service';
import { ControlService } from 'src/app/Service/control.service';
import { MQTTOperation } from 'src/app/Service/mqttoperation.service';
@Component({
  selector: 'app-save-register-control-value',
  templateUrl: './save-register-control-value.component.html'
})
export class SaveRegisterControlValueComponent implements OnInit {
  SetObj: { [key: string]: any } = {};
  isdisplaySend: boolean = false;
  successMsg: string = '';
  errorMsg: string = '';
  meterMasterId: number = 0;
  widgetType: string = '';
  RegisterData: any[] = [];
  RegisterDataId: number = 0;
  RegisterValue: any = '';
  ControlDetailsId: number = 0;
  EnergymeterId: string = '';
  RegisterControlValForm: FormGroup;
  displayMessage: { [key: string]: string } = {};
  private genericValidator: GenericValidator;
  private validationMessages: { [key: string]: { [key: string]: string } };
  ReqObj: { [key: string]: any } = {};
  constructor(public dialogRef: MatDialogRef<SaveRegisterControlValueComponent>, private authService: AuthService, private form: FormBuilder, private GSMConfigService: GSMConfigurationService, @Inject(MAT_DIALOG_DATA) public data: any, private controlservice: ControlService, private mqttoperation: MQTTOperation) {
    if (data) {
      this.meterMasterId = data.MeterMasterId;
      this.widgetType = data.widgetType;
      this.RegisterDataId = data.RegisterDataId;
      this.RegisterValue = data.RegisterValue;
      this.ControlDetailsId = data.ControlDetailsId;
      this.EnergymeterId = data.MeterId;
    }

    // Raise Validation message
    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages = resp.RegisterControlValForm;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });
  }

  ngOnInit(): void {
    this.RegisterControlValForm = this.form.group({
      RegisterDataId: ['', [Validators.required]],
      RegisterValue: [''],
      RegisterValue1: [false]
    });

    if (this.RegisterDataId > 0) {
      if (this.widgetType == 'Toggle') {
        this.widgetType = 'UpdateToggle';
      }
      else {
        this.widgetType = 'UpdateTextBox';
      }
    }

    this.GetRegisterdata(this.meterMasterId);
    if (this.RegisterDataId > 0) {
      this.isdisplaySend = true;
      this.RegisterControlValForm.patchValue({
        RegisterDataId: this.RegisterDataId.toString(),
        RegisterValue: this.RegisterValue,
        RegisterValue1: this.RegisterValue == 'true' || this.RegisterValue == 1 ? true : false
      });
    }

    // Call service for validation on valu change
    this.RegisterControlValForm.valueChanges.subscribe(
      value => this.displayMessage = this.genericValidator.processMessages(this.RegisterControlValForm)
    );

  }

  // Get Register Data
  GetRegisterdata(id) {
    if (id != null) {

      this.GSMConfigService.GetRegisterdata(id, 'N', this.widgetType, '').subscribe(
        (result) => {
          if (result.listRegisterdata != null) {
            this.RegisterData = result.listRegisterdata;
          }
        },
        (error) => {
          this.errorMsg = error;
        }
      );
    }
  }

  // Close Icon event
  Close() {
    this.dialogRef.close();
  }

  // Save User Control Screen Data
  SaveUserControlScreenData() {

    if (this.widgetType == 'Toggle' || this.widgetType == 'UpdateToggle') {
      this.RegisterControlValForm.controls['RegisterValue'].clearValidators();
      this.RegisterControlValForm.controls['RegisterValue'].updateValueAndValidity();
    }
    else {
      this.RegisterControlValForm.controls['RegisterValue'].setValidators([Validators.required]);
      this.RegisterControlValForm.controls['RegisterValue'].updateValueAndValidity();
    }

    if (this.RegisterControlValForm.invalid) {
      this.RegisterControlValForm.updateValueAndValidity();
      this.displayMessage = this.genericValidator.processMessages(this.RegisterControlValForm, true);
      return;
    }

    var reqparam = {
      RegisterDataId: this.RegisterControlValForm.value.RegisterDataId,
      RegisterValue: this.widgetType == 'Toggle' || this.widgetType == 'UpdateToggle' ? this.RegisterControlValForm.value.RegisterValue1 : this.RegisterControlValForm.value.RegisterValue,
      IsToggle: this.widgetType == 'Toggle' || this.widgetType == 'UpdateToggle' ? 'Y' : 'N',
      ControlDetailsId: this.ControlDetailsId
    };

    this.controlservice.SaveUserControlScreenData(reqparam).subscribe(
      (result) => {
        if (result) {
          this.successMsg = 'Data saved successfully!!';
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // Control Button Click
  ControlClick() {
    var value = this.RegisterControlValForm.value.RegisterValue1;

    this.RegisterControlValForm.patchValue({
      RegisterValue1: value == false ? true : false
    });
  }

  SendDatabyMQTT() {
    this.errorMsg = '';
    this.successMsg = '';
    this.SetObj = {};
    // Get the selected TagId
    const selectedRegister = this.RegisterData.find(r => r.RegisterDataId == this.RegisterControlValForm.value.RegisterDataId);
    if (!selectedRegister) {
      this.errorMsg = 'Invalid Register selected';
      return;
    }
    const TagId = selectedRegister.TagId;
    // Determine the register value based on widget type
    const isToggleWidget = this.widgetType == 'UpdateToggle' || this.widgetType == 'Toggle';
    const registerValue = isToggleWidget
      ? (this.RegisterControlValForm.value.RegisterValue1 ? 1 : 0)
      : this.RegisterControlValForm.value.RegisterValue;
    // Build SetObj
    this.SetObj[TagId] = registerValue;
    this.SetObj['UID'] = this.EnergymeterId.slice(-3);
    // Construct the payload
    const topicPrefix = this.EnergymeterId.slice(0, -3) + '000';
    const payload = {
      Topic: topicPrefix,
      Data: [this.SetObj],
    };
    // Prepare the request object
    const reqObj = {
      Topic: topicPrefix,
      PublishMessageJson: JSON.stringify(payload),
      IsFromControlPage: 'Y',
    };
    const reqData = { Data: [reqObj] };
    // Publish data to MQTT
    this.mqttoperation.PublishdatabyMQTT(reqData).subscribe(
      (result: any) => {
        this.successMsg = result == '0'
          ? 'Configuration value submitted successfully'
          : 'Submission failed, something went wrong';
      },
      (error) => {
        this.errorMsg = 'Error: ' + (error.message || 'Failed to submit data');
      }
    );
  }
}
